import { render } from "./VerProducto.vue?vue&type=template&id=48362bbc"
import script from "./VerProducto.vue?vue&type=script&lang=js"
export * from "./VerProducto.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__